import { Route } from '@angular/router';

import {
  VehicleAgentNotificationConfirmationComponent,
  VehicleOfflineBindComponent
} from '@amfam/policy/add-vehicle/feature';

import { AgentHelpComponent } from '../agent-help/agent-help.component';
import { AgentNotificationConfirmationComponent } from '../agent-notification-confirmation/agent-notification-confirmation.component';
import { FuturePaymentsScheduleComponent } from '../future-payments-schedule/future-payments-schedule.component';
import { HasReplaceVehicleGuard } from '../guards/has-replace-vehicle.guard';
import { QuickQuoteComparisonComponent } from '../quick-quote-comparison/quick-quote-comparison.component';
import { QuickQuoteContainerComponent } from '../quick-quote-container/quick-quote-container.component';
import { QuoteOrBindComponent } from '../quote-or-bind/quote-or-bind.component';
import { ReplaceVehicleConfirmationComponent } from '../replace-vehicle-confirmation/replace-vehicle-confirmation.component';
import { ReviewQuoteContainerComponent } from '../review-quote-container/review-quote-container.component';
import { QuickQuoteResolve } from '../services/quick-quote-resolver.service';
import { UnderwritingQuestionListComponent } from '../underwriting-question-list/underwriting-question-list.component';
import { YearVinLookupComponent } from '../year-vin-lookup/year-vin-lookup.component';
import { LoanInfoComponent } from './../loan-info/loan-info.component';

export const ReplaceVehicleRoutes: Route[] = [
  {
    path: ':id',
    component: QuickQuoteContainerComponent,
    data: { breadcrumb: 'Quick Quote or Replace a Vehicle' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: QuoteOrBindComponent,
        data: { breadcrumb: false }
      },
      {
        path: 'quote',
        component: ReviewQuoteContainerComponent,
        canActivate: [HasReplaceVehicleGuard],
        resolve: { resolvedData: QuickQuoteResolve },
        data: { breadcrumb: 'useResolvedData' }
      },
      {
        path: 'quick-quote',
        component: QuickQuoteComparisonComponent,
        canActivate: [HasReplaceVehicleGuard],
        resolve: { resolvedData: QuickQuoteResolve },
        data: { breadcrumb: 'useResolvedData' }
      },
      {
        path: 'agent-help',
        component: AgentHelpComponent,
        canActivate: [HasReplaceVehicleGuard],
        resolve: { resolvedData: QuickQuoteResolve },
        data: { breadcrumb: 'useResolvedData' }
      },
      {
        path: 'notification',
        component: AgentNotificationConfirmationComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: 'Quick Quote' }
      },
      {
        path: 'underwriting',
        component: UnderwritingQuestionListComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'confirmation',
        component: ReplaceVehicleConfirmationComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'year-vin',
        component: YearVinLookupComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: false }
      },
      {
        path: 'loan-info',
        component: LoanInfoComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'payment-schedule',
        component: FuturePaymentsScheduleComponent,
        canActivate: [HasReplaceVehicleGuard],
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'agent-helps',
        component: VehicleOfflineBindComponent,
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'agent-notification-confirmation',
        component: VehicleAgentNotificationConfirmationComponent,
        data: { breadcrumb: 'Replace a Vehicle' }
      },
      {
        path: 'classic-year-vin',
        component: YearVinLookupComponent,
        data: { breadcrumb: false }
      }
    ]
  }
];
